import React from "react";
import T from "prop-types";
import { getFormValues } from "redux-form";
import { connect } from "react-redux";
import api from "APP_ROOT/api";
import { reloadSilent } from "MODULES/Shipping/actions";
import { SHIPPING_CHECKLIST } from "MODULES/shared/components/CommercialInvoice/helpers";

const Save = props => {
  if (!props.salesOrderId) return null;

  return (
    <button
      disabled={props.submitting}
      type="button"
      className="btn btn-primary"
      style={{ paddingLeft: "5px", paddingRight: "5px" }}
      onClick={e => {
        e.preventDefault();
        api.salesOrders.commercialInvoice
          .save(props.salesOrderId, props.values)
          .then(() => {
            props.setCurrentForm
              ? props.setCurrentForm(SHIPPING_CHECKLIST)
              : props.close();
            props.reload && props.reload();
          });
      }}
    >
      {props.submitting ? (
        <i className="fa fa-cog fa-spin fa-fw fa-lg" />
      ) : (
        "Save"
      )}
    </button>
  );
};

export default connect(
  (state, ownProps) => ({
    values: getFormValues(ownProps.formName)(state)
  }),
  (dispatch, ownProps) => ({
    reload: () => dispatch(reloadSilent(ownProps.salesOrderDetail))
  })
)(Save);

Save.propTypes = {
  close: T.func.isRequired,
  reload: T.func.isRequired,
  salesOrderId: T.number.isRequired,
  setCurrentForm: T.func,
  submitting: T.bool.isRequired,
  values: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/CommercialInvoice/Form/Save.jsx